import { PolyIcon, ToggleSwitchInput, ToolTip } from "elements";
import React from "react";
import { useTranslation } from "utilities/i18n";

// THE CODE BELOW HAS BEEN HARD CODED DUE TO THE BACKEND NOT BEING READY YET.
// IT WILL BE FEATURE FLAGGED AND NOT HAVE ANY IMPACT ON PRODUCTION

export const DeviceAlertsSettings: React.FC<{ id: string }> = ({ id }) => {
  const { t } = useTranslation();

  return (
    <div className="settings">
      <div className="card title-card">{t("DEVICE_ALERTS")}</div>
      <div className="details grid form">
        <div className="form-group">
          <div className="col-6"></div>
          <div className="col-3">
            <span className="legend">Inheritance</span>
            <ToolTip
              iconReplacement={<PolyIcon icon="info_circle" />}
              position="right"
              iconTitle="help"
            >
              <p>{t("NETWORK_DIAGNOSTIC_TESTING_TOOLTIP")}</p>
            </ToolTip>
          </div>
          <div className="col-3">
            <span className="legend">Settings Lock</span>
            <ToolTip
              iconReplacement={<PolyIcon icon="info_circle" />}
              position="right"
              iconTitle="help"
            >
              <p>{t("NETWORK_DIAGNOSTIC_TESTING_TOOLTIP")}</p>
            </ToolTip>
          </div>

          <label className="col-3 text-right">Headset Charging:</label>
          <div className="col-1 vcenter">
            <ToggleSwitchInput
              name="network-testing"
              checked={false}
              onChange={() => {}}
            />
          </div>
          <div className="col-2"></div>
          <div className="col-3"></div>
          <div className="col-3">
            <PolyIcon icon="unlocked" />
          </div>

          <label className="col-3 text-right">Mute Alert:</label>
          <div className="col-1 vcenter">
            <ToggleSwitchInput
              name="network-testing"
              checked={false}
              onChange={() => {}}
            />
          </div>
          <div className="col-2"></div>
          <div className="col-3"></div>
          <div className="col-3">
            <PolyIcon icon="unlocked" />
          </div>

          <label className="col-3 text-right">
            App/Headset Software Update:
          </label>
          <div className="col-1 vcenter">
            <ToggleSwitchInput
              name="network-testing"
              checked={false}
              onChange={() => {}}
            />
          </div>
          <div className="col-2"></div>
          <div className="col-3"></div>
          <div className="col-3">
            <PolyIcon icon="unlocked" />
          </div>

          <label className="col-3 text-right">Background Noise Detected:</label>
          <div className="col-1 vcenter">
            <ToggleSwitchInput
              name="network-testing"
              checked={false}
              onChange={() => {}}
            />
          </div>
          <div className="col-2"></div>
          <div className="col-3">User-specific</div>
          <div className="col-3">
            <PolyIcon icon="unlocked" />
          </div>

          <label className="col-3 text-right">Headset Disconnected:</label>
          <div className="col-1 vcenter">
            <ToggleSwitchInput
              name="network-testing"
              checked={false}
              onChange={() => {}}
            />
          </div>
          <div className="col-2"></div>
          <div className="col-3">Global</div>
          <div className="col-3">
            <PolyIcon icon="unlocked" />
          </div>
        </div>
      </div>
    </div>
  );
};
